var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConstruction = function SvgConstruction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#construction_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#13CFE8",
    d: "M4.75 0A4.75 4.75 0 0 0 0 4.75v.5a.752.752 0 0 0 1.088.672l1.428-.716c.318.335.725.578 1.172.703l-.55 8.094a1.867 1.867 0 1 0 3.725 0l-.544-8.01A2.56 2.56 0 0 0 8.162 5H9.5v.25c0 .416.334.75.75.75s.75-.334.75-.75V.75a.75.75 0 0 0-.75-.75.75.75 0 0 0-.75.75V1H8.162a2.57 2.57 0 0 0-2.03-1zM9.5 3.5H7.75a.75.75 0 0 0-.672.416c-.178.359-.547.584-.947.584H4.37c-.4 0-.769-.228-.947-.584a.746.746 0 0 0-1.006-.335l-.828.41A3.255 3.255 0 0 1 4.75 1.5h1.381c.4 0 .769.228.947.584a.75.75 0 0 0 .672.416H9.5zm9 11H15V13c0-.275-.225-.5-.5-.5s-.5.225-.5.5v1.5h-1.5V10h6zm-6.61-7.094c-.556.372-.89.997-.89 1.666V14.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V9.072c0-.669-.334-1.294-.89-1.666L17 6V1.5a1.5 1.5 0 0 0-3 0V6zM15 1.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "construction_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v16H0z"
  })))));
};
export default SvgConstruction;